import React, { FC, useEffect, useMemo, useState } from 'react'
import './WaitEmailValidation.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { useSelector } from 'react-redux'
import { CombinedReducers } from 'app_events/index'
import AuthService from 'app_services/secure/auth/authService'
import UserService from 'app_services/user/userService'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { useHistory } from 'react-router-dom'

const emailImage = require('app_assets/images/resources/email-verification.png')
const INACTIVITY_TIME = 60*1000*5

interface IWaitEmailValidationProps {

}

const WaitEmailValidation: FC<IWaitEmailValidationProps> = () => {
  const { user } = useSelector((state: CombinedReducers) => state.auth)
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const authService = useMemo(() => new AuthService(), [])
  const userService = useMemo(() => new UserService(), [])
  const screenNotification = useMemo(() => new ScreenNotificationsUtil(), [])

  useEffect(() => {
    const interval = setTimeout(() => {
      authService.logout()
    }, INACTIVITY_TIME)
    return () => {
      clearInterval(interval)
    }
  }, [])

  const handleClickLogout = () => {
    authService.logout()
    history.push('/')
  }

  const resendEmail = async () => {
    if (user?.data?.username != undefined){
      setLoading(true)
      const response = await userService.sendEmailConfirmation(user?.data?.username)
      if (response?.code === 200) {
        screenNotification.showSuccessTimer({ title: "Enviado", text: "Se ha enviado un nuevo código a tu correo electrónico" })
      }
      setLoading(false)
    }
  }

  return (
    <div className="wait-email-validation--layout">
      <img className='wait-email-validation--image' src={emailImage} alt="" />
      <div className="wait-email-validation--info">
        <TextComponent fontWeight={600} type='subtitle'>Confirma tu email</TextComponent>
        <TextComponent fontWeight={600}>Hemos creado tu usuario en nuestro Campus Digital y te enviamos un correo de Bienvenida.  Requerimos confirmar tu correo:</TextComponent>
        <TextComponent fontWeight={600}>
            1. Abre el mensaje de <span className='wait-email-validation--blue-text'>"confirmación de correo electrónico" </span> que te hemos enviado al correo registrado: <span className='wait-email-validation--blue-text'>{user?.data?.email}</span>
        </TextComponent>
        <TextComponent fontWeight={600}>¿Esta dirección es incorrecta? Vuelve a registrarte con un email diferente <span onClick={handleClickLogout} style={{ cursor: 'pointer' }}>cerrando sesión aquí</span>.</TextComponent>
        <TextComponent fontWeight={600}>Revisa las carpetas de spam o notificaciones en tu bandeja de entrada.</TextComponent>
        <TextComponent fontWeight={600}>¿No has recibido nada o el email ha caducado? </TextComponent>
        <ButtonComponent onClick={resendEmail} loading={loading} textTransform='none' color="var(--primary)" width="fit-content">
          Enviar de nuevo
        </ButtonComponent>
        <TextComponent fontWeight={600}>
          2. Pulsa en el mensaje de confirmación<span className='wait-email-validation--blue-text'>"Confirmar tu email"</span>
        </TextComponent>
        <TextComponent fontWeight={600}>Asi confirmaremos que es tu email</TextComponent>
      </div>
    </div>
  )
}

export default WaitEmailValidation
